import { humanCase } from '@dotfile/shared/common';

import {
  PropertyMappingEntityEnum,
  RiskLevelEnum,
  RiskModeEnum,
  RiskModel,
} from '../../shared/models';
import { DefaultPropertiesBuilder } from './default-properties-builder';
import { Property, PropertyTypeEnum } from './types';

export type RiskPropertyKey = keyof Omit<
  RiskModel,
  | 'id'
  | 'case'
  | 'caseId'
  | 'isCurrent'
  | 'user'
  | 'userId'
  | 'automation'
  | 'workflow'
  | 'deletedAt'
>;

export const getRiskDefaultPropertiesDefinition = (): Record<
  RiskPropertyKey,
  Property<PropertyTypeEnum>
> =>
  new DefaultPropertiesBuilder<RiskModel>(PropertyMappingEntityEnum.case)
    .addProperty('mode', PropertyTypeEnum.choices, {
      settings: {
        allowMultiple: false,
        options: Object.values(RiskModeEnum).map((key) => ({
          key,
          label: humanCase(key),
        })),
      },
    })
    .addProperty('level', PropertyTypeEnum.choices, {
      settings: {
        allowMultiple: false,
        options: Object.values(RiskLevelEnum).map((key) => ({
          key,
          label: humanCase(key),
        })),
      },
    })
    .addProperty('comment', PropertyTypeEnum.text)
    .addProperty('score', PropertyTypeEnum.numeric)
    .addProperty('components', PropertyTypeEnum.unknown)
    .addProperty('flags', PropertyTypeEnum.unknown)
    .addProperty('createdAt', PropertyTypeEnum.date)
    .addProperty('updatedAt', PropertyTypeEnum.date)
    .getDefinition();
